export enum SnackbarNotificationType {
  Success = 'success',
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}

export interface SnackbarNotificationBase {
  duration?: number;
  type: SnackbarNotificationType;
  message: string;
  onClick?: () => void;
}

export interface SnackbarNotification extends SnackbarNotificationBase {
  id: string;
}

export interface Props {
  notifications: SnackbarNotification[];
  onCloseAdditional: (id: string) => void;
}
